<template>
  <div>
  <!--region ismobile-->
  <keep-alive v-if="isMobile">
    <a-drawer
      wrapClassName="m-drawer-mobile"
      placement="left"
      :closable="false"
      @close="onClose"
      :visible="visible"
      width="300"
    >
      <div class="m-drawer-header">
        <div class="photos-wrapper">
          <img :src="getAuth.foto" alt="" />
        </div>
        <a-affix :offsetTop="this.top">
          <span>Halo,</span>
          <h3 class="m-remove co-white">{{ getAuth.fullname }}</h3>
        </a-affix>
      </div>
      <div class="m-drawer-body">
        <a-card class="m-drawer-tools">
          <a-menu mode="horizontal">
            <a-menu-item key="poweroff">
              <router-link :to="{ name: 'logout' }">
                <a-icon type="poweroff" />Keluar
              </router-link>
            </a-menu-item>
            <a-menu-item key="apps">
              <router-link :to="{ name: 'app' }">
                <Icon type="icon-pandapakita" style="font-size:15px!important"/>
              </router-link>
            </a-menu-item>
            <a-menu-item key="home">
              <router-link :to="{ name: 'dashboard' }">
                <a-icon type="home" />
              </router-link>
            </a-menu-item>
            <a-menu-item key="notification" @click="handleNotification">
              <a-badge
                class="m-badge m-badge-small"
                :count="countNotif"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="
                  getNotification.aksi.length > 0 ||
                    getNotification.informasi.length > 0
                "
              >
                <a-icon type="notification" />
              </a-badge>
              <a-icon type="notification" v-else />
            </a-menu-item>
          </a-menu>
        </a-card>
        <H-Menu />
      </div>
      <div class="nav-menu-footer">
        <div class="nav-menu-footerbox">
          <a-row type="flex" justify="space-between">
            <div>
              <span @click="handleVersionChanges" style="cursor: pointer;">© Harmoni {{ appVersion }}</span>
            </div>
            <div>
              <div v-if="progressExport.user == getAuth.username && progressExport.data.length > 0">
                <a-tooltip
                  placement="topLeft"
                  :title="progressExport.visible_dtl ? 'Hide Export Progress' : 'Show Export Progress'"
                  arrow-point-at-center
                >
                  <div @click="viewProgressBar" style="cursor: pointer;">
                    <a-icon type="sync" spin v-if="!progressExport.visible_dtl"/>
                    Processing Export
                    <a-icon type="close" v-if="progressExport.visible_dtl"/>
                  </div>
                </a-tooltip>
              </div>
              &nbsp;
            </div>
          </a-row>
          <a-row class="nav-menu-footer_dtl" v-if="progressExport.visible_dtl">
            <a-divider dashed style="margin: 12px 0!important;"/>
            <div id="scroll_boxdtl" class="nav-menu-boxdtl" v-if="progressExport.data.length > 0">
              <div :key="index" v-for="(progressdata, index) in progressExport.data" class="scroll_boxdtl2">
                <div v-if="progressdata.availableDownload" @click="downloadresult(progressdata.filename)" class="pointer">
                  <a-tooltip
                    placement="topLeft"
                    :title="'Download Files'"
                    arrow-point-at-center
                  >
                  {{ progressdata.filename }} <a-icon v-if="progressdata.end != null" type="check-circle" theme="filled" /> 
                  </a-tooltip>
                </div>
                <div v-else class="d-flex justify-between">
                  <span>{{ progressdata.filename }}</span> 
                  <span>{{ moment(moment().diff(moment(progressdata.start))).format('mm:ss') }}</span>
                </div>
                <a-progress
                  v-if="Number(progressdata.progress) < 100"
                  class="nav-menu-footer_progress"
                  :percent="Number(progressdata.progress)"
                  status="active"
                  :show-info="true"
                />
                <!-- :stroke-color="{
                from: '#108ee9',
                to: '#87d068',
              }" -->
              </div>
            </div>
          </a-row>
        </div>
      </div>
    </a-drawer>
  </keep-alive>
  <!--endregion-->

  <a-layout-sider v-else class="m-sider" theme="light" width="300">
    <div :class="isMobile ? 'm-drawer-header' : 'm-sider-header'">
      <div class="d-flex justify-between">
        <div class="photos-wrapper">
          <img :src="getAuth.foto" alt="" />
      
        </div>
        <img
          keep-alive
          class="m-drawer-brand"
          src="@/assets/logo.png"
          alt="brand"
        />
      </div>
      <a-affix :offsetTop="this.top">
        <span>Halo,</span>
        <h3 class="m-remove co-white">{{ getAuth.fullname }}</h3>
      </a-affix>
    </div>
    <div style="padding-right: 0.5em!important;">
    <a-card class="m-drawer-tools mod-tools">
      <a-menu mode="horizontal" style="border: 2px solid #ffffff00 !important;
              border-radius: 0px 5px 5px 0px !important;">
        <a-menu-item key="poweroff">
          <router-link :to="{ name: 'logout' }">
            <a-icon type="poweroff" />Keluar
          </router-link>
        </a-menu-item>
        <a-menu-item key="apps">
          <router-link :to="{ name: 'app' }">
            <Icon type="icon-pandapakita" style="font-size:15px!important"/>
          </router-link>
        </a-menu-item>
        <a-menu-item key="home">
          <router-link :to="{ name: 'dashboard' }">
            <a-icon type="home" />
          </router-link>
        </a-menu-item>
        <a-menu-item key="notification" @click="handleNotification">
          <a-badge
            class="m-badge m-badge-small"
            :count="countNotif"
            :numberStyle="{ backgroundColor: 'red' }"
            v-if="getNotification.aksi.length > 0 ||
              getNotification.informasi.length > 0
              "
          >
            <a-icon type="notification" />
          </a-badge>
          <a-icon type="notification" v-else />
        </a-menu-item>
      </a-menu>
    </a-card>
    </div>

    <div class="m-drawer-body navmenu-left">
      <H-Menu />
    </div>
    <div class="nav-menu-footer">
      <div class="nav-menu-footerbox">
        <a-row type="flex" justify="space-between">
          <div>
            <span @click="handleVersionChanges" style="cursor: pointer;">© Harmoni {{ appVersion }}</span>
          </div>
          <div>
            <div v-if="progressExport.user == getAuth.username && progressExport.data.length>0">
              <a-tooltip
                placement="topLeft"
                :title="progressExport.visible_dtl ? 'Hide Export Progress' : 'Show Export Progress'"
                arrow-point-at-center
              >
                <div @click="viewProgressBar" style="cursor: pointer;">
                  <a-icon type="sync" spin v-if="!progressExport.visible_dtl"/>
                  Processing Export
                  <a-icon type="close" v-if="progressExport.visible_dtl"/>
                </div>
              </a-tooltip>
            </div>
            &nbsp;
          </div>
        </a-row>
        <a-row class="nav-menu-footer_dtl" v-if="progressExport.visible_dtl">
          <a-divider dashed style="margin: 12px 0!important;"/>
          <div id="scroll_boxdtl" class="nav-menu-boxdtl" v-if="progressExport.data.length>0">
            <div :key="index" v-for="(progressdata,index) in progressExport.data" class="scroll_boxdtl2">
              <div v-if="progressdata.availableDownload" @click="downloadresult(progressdata.filename)" class="pointer">
                <a-tooltip
                  placement="topLeft"
                  :title="'Download Files'"
                  arrow-point-at-center
                >
                {{ progressdata.filename }} <a-icon v-if="progressdata.end != null" type="check-circle" theme="filled" /> 
                </a-tooltip>
              </div>
              <div v-else class="d-flex justify-between">
                <span>{{ progressdata.filename }}</span> 
                <span>{{ moment(moment().diff(moment(progressdata.start))).format('mm:ss') }}</span>
              </div>
              <a-progress
                v-if="Number(progressdata.progress)<100"
                class="nav-menu-footer_progress"
                :percent="Number(progressdata.progress)"
                status="active"
                :show-info="true"
              />
              <!-- :stroke-color="{
                from: '#108ee9',
                to: '#87d068',
              }" -->
            </div>
          </div>
        </a-row>
      </div>
    </div>
  </a-layout-sider>
  </div>
</template>

<script>
import Menu from "./Menu";
import { mapGetters } from "vuex";
import moment from "moment";
import message from "@/mixins/HandleMessage";

export default {
  name: "Navigation",
  mixins: [message],
  components: {
    "H-Menu": Menu
  },
  data() {
    return {
      top: 10,
      visible: false,
      notification: false,
      progressExport: {
        visible_dtl: false,
        user: null,
        data: [],
        timerloop: null
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getNotification","getExportDataResult", "appVersion",]),
    countNotif() {
      let count =
        this.getNotification.aksi.length +
        this.getNotification.informasi.length;
      return count;
    },
    initialVersion() {
      return this.setNextVersion("0.1.1-alpha");
    },
  },
  created() {},
  methods: {
    moment,
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleNotification() {
      this.$store.dispatch("SET_NOTIFICATION_VIEW");
    },
    viewProgressBar() {
      this.progressExport.visible_dtl = !this.progressExport.visible_dtl;
    },
    createLoop() {
      this.progressExport.timerloop = setInterval(() => {
        Event.$emit("exportlistdata", { tipe: "loop" });
      }, 5000)
    },
    stopLoop() {
      clearInterval(this.progressExport.timerloop);
    },
    getexportlistdata(val) {
      this.$store.dispatch("getExportDataStatus", {
        auth: this.getAuth,
      })
        .then(() => {
          let datalist = this.getExportDataResult;
          let datalist_result = [];
          for (let i = 0; i < datalist.length; i++) {
            let tlc_p = datalist[i].filename.substring(0, 3);
            if (tlc_p == this.getAuth.username) {
              this.progressExport.user = tlc_p;

              let starttime = moment(datalist[i].start);
              let endtime = moment();
              let result = endtime.diff(starttime, 'minutes')
              if (datalist[i].end == null) {
                datalist[i].progress = (result <= 30 ? Math.round((result / 30) * 100) : 99.9);
                datalist[i]['availableDownload'] = (datalist[i].progress >= 100 && datalist[i].end != null ? true : false);
              } else {
                datalist[i].progress = 100;
                datalist[i]['availableDownload'] = true;
              }
              datalist_result.push(datalist[i])
            }
          }

          this.progressExport.data = [];
          if (this.progressExport.user == this.getAuth.username) {
            this.progressExport.data = datalist_result;
          }

          if (this.progressExport.data.length == 0) {
            this.stopLoop();
            this.progressExport.visible_dtl = false;
          } else {
            if (val && val.tipe == "new_loop") {
              this.stopLoop();
              this.createLoop();
            }
          }
        });
    },
    downloadresult(name) {
      this.$store.dispatch("getExportFiles", {
        auth: this.getAuth,
        param: {
          file_name : name
        }
      }).then((response) => {
          // window.open(this.$serviceUrl + response.data.url, "_blank");

          //var dataURI = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8;base64," +response.data.file;
          //window.open(dataURI);

          var element = 'data:application/vnd.ms-excel;charset=UTF-8;base64,' + response.data.file;
          let downloadElement = document.createElement('a');
          downloadElement.href = element;
          downloadElement.target = '_self';
          // use .csv as extension on below line if you want to export data as csv
          downloadElement.download = name;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          downloadElement.remove();

          this.$store.dispatch("deleteExportFiles", {
            auth: this.getAuth,
            param: {
              filename: name
            }
          }).then(() => {
            Event.$emit("exportlistdata");
          }).catch((err) => {
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-basic", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses);
            }
          });
      }).catch((err) => {
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-basic", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses);
        }
      });
    },
    handleVersionChanges() {
      const route = this.$router.resolve({
        name: "ChangeLogs",
      });
      window.open(route.href, "_blank");
      // var newWin = open('url', 'windowName');
      // newWin.document.write('html to write...');
    }
  },
  mounted() {
    Event.$on("drawerNav", this.onClose);
    Event.$on("notificationToggle", this.handleNotification);
    Event.$on("exportlistdata", this.getexportlistdata);

    this.createLoop();
  }
};
</script>

<style lang="less" scoped>
.photos {
  &-wrapper {
    width: 64px;
    height: 64px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    margin-bottom: 12px;
    border-radius: 12px;

    img {
      width: 100%;
      align-self: flex-start;
    }
  }
}
.nav {
  &-menu{
    &-footerbox{
      font-size: 0.8em;
      padding: 5px 10px 5px 10px;
      border-radius: 5px 0px 10px 0px;
      background: @primary-color;
      color: white;
    }
    &-footer {
      background: white;
    }

    &-footer_dtl{
      font-size: 1em;
      color: white;
      padding: 9px 5px 3px 0px;
    }

    &-footer_progress{
      font-size: 1.2em;
      color: white!important;
      padding-right: 3px;
    }

    &-boxdtl{
      color: white;
      overflow-x: hidden;
      max-height: 150px;
    }
  }
}
</style>

<style lang="less">
.ant-progress-text{
  color: white!important;
  font-size: 0.9em!important;
}

#scroll_boxdtl::-webkit-scrollbar {
    width: 5px;
}

#scroll_boxdtl::-webkit-scrollbar-track {
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    //border-radius: 10px;
    background: rgba(255, 255, 255, 0.3) 
}

#scroll_boxdtl::-webkit-scrollbar-thumb {
    //border-radius: 10px;
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
    background: #888; 
}

#scroll_boxdtl::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.pointer{
  cursor: pointer;
  margin-bottom: 5px;
}

.scroll_boxdtl2{
  border-left: 3px solid white;
  padding: 3px 5px 0px 5px;
  margin: 5px 0px 5px 0px;
  border-radius: 2px;
  background: rgb(0,0,0);
  background: -moz-linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(42,143,104,0.75) 75%);
  background: -webkit-linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(42,143,104,0.75) 75%);
  background: linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(42,143,104,0.75) 75%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#2a8f68",GradientType=1);
}

.scroll_boxdtl2:hover {
  background: rgb(0,0,0);
  background: -moz-linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(119,209,174,0.75) 75%);
  background: -webkit-linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(119,209,174,0.75) 75%);
  background: linear-gradient(151deg, rgba(0,0,0,0) 0%, rgba(119,209,174,0.75) 75%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#77d1ae",GradientType=1);
}

.mod-tools{
  border: 1px solid #ffffff00!important;
}

.navmenu-left::-webkit-scrollbar {
    width: 0.4em;
  }
 
.navmenu-left::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
}
 
.navmenu-left::-webkit-scrollbar-thumb {
  border-radius: 10px 10px 11px 10px;
  background-color: @primary-color;
}

.ant-menu-item .anticon{
  margin-right: 5px!important;
  margin-left: 5px!important;
}
</style>
